import React, { useCallback } from 'react';

import { Input, CheckBox, Select, SelectProps, FormControlBase } from 'Modules/ui2';
import { wrapFormComponent } from 'Modules/core/forms';

import { ParticipantSelect } from './Dadata';


export const InputField = wrapFormComponent(Input);
export const CheckBoxField = wrapFormComponent(CheckBox);
export const SelectField = wrapFormComponent(Select);

export const ParticipantSelectField = wrapFormComponent(({
    name,
    value,
    onChange,
    onBlur,
    onFocus,
    ...props
}) => (
    <ParticipantSelect
        inputProps={{
            name,
            onBlur,
            onFocus,
            ...props,
        }}
        value={value}
        onChange={onChange}
    />
));
type ParticipantSelectFieldWithMutateProps = FormControlBase<any> & {
    mutate?: (value: any) => void;
}
export const ParticipantSelectFieldWithMutate =
wrapFormComponent<ParticipantSelectFieldWithMutateProps>(({
    name,
    value,
    onChange,
    onBlur,
    onFocus,
    active,
    mutate,
    ...props
}) => (
    <ParticipantSelect
        inputProps={{
            name,
            onBlur,
            onFocus,
            ...props,
        }}
        value={value}
        onChange={value => {
            if (mutate)
                mutate(value);
            onChange(value);
        }}
    />
));

type CertificateFieldProps = SelectProps & { mutate: (value: any) => void }
export const CertificateField = wrapFormComponent<CertificateFieldProps>(({
    onChange,
    mutate,
    ...props
}) => (
    <Select
        onChange={useCallback(
            cert => {
                mutate(cert);
                onChange(cert);
            },
            [mutate, onChange],
        )}
        {...props}
    />
));
